import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { JvService } from '../../services/JvService';
import * as BullCache from "../../util/BullCache";

function Jv() {

    const [client, setClient] = useState([]);
    const [selectedClient1, setSelectedClient1] = useState('');
    const [selectedClient2, setSelectedClient2] = useState('');
    const [paymentType, setPaymentType] = useState('CASH');
    const [selectedAmount, setSelectedAmount] = useState('');
    const [selectedRemark, setSelectedRemark] = useState('');
    const filteredClientsForCredit = client.filter(c => c.userid !== selectedClient1);
    const [selectedBalance1, setSelectedBalance1] = useState(0);  
    const [selectedBalance2, setSelectedBalance2] = useState(0);  
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);

    var user = BullCache.getFromCache("user");
    const navigate = useNavigate();

    useEffect(() => {
        if (!user.adminId) return;
        JvService.getUsers({ 'adminId': user.adminId }).then(res => {
            if (res.code === 1) {
                if (res.data.userList.length > 0) {
                    setClient(res.data.userList);
                }
            }
        });
    }, [user.adminId]);

    const handleBrokerChange1 = (selectedOption) => {
        if (selectedOption) {
            setSelectedClient1(selectedOption.value);

            const clientData = client.find(c => c.userid === selectedOption.value);
            if (clientData) {
                setSelectedBalance1(clientData.balance);
            }
        } else {
            setSelectedClient1('');
            setSelectedBalance1(0); 
        }
    };


    const handleBrokerChange2 = (selectedOption) => {
        if (selectedOption) {
            setSelectedClient2(selectedOption.value);

            const clientData = client.find(c => c.userid === selectedOption.value);
            if (clientData) {
                setSelectedBalance2(clientData.balance);
            }
        } else {
            setSelectedClient2('');
            setSelectedBalance2(0);  
        }
    };

    const handlePaymentTypeChange = (e) => {
        setPaymentType(e.target.value);
    };

    const handleAmountChange = (e) => {
        setSelectedAmount(e.target.value);
    };

    const handleRemarkChange = (e) => {
        setSelectedRemark(e.target.value);
    };

    const handleDateChange = (e) => {
        setSelectedDate(e.target.value);
    };
    const jvClear = () => {
        setSelectedClient1('');
        setSelectedClient2('');
        setSelectedDate(new Date().toISOString().split('T')[0]);  
        setSelectedAmount('');
        setSelectedRemark('');
        setPaymentType('CASH');

    };
    const jvEntry = () => {
        if (!selectedClient1 || !selectedClient2 || !selectedAmount || !selectedDate || parseFloat(selectedAmount) <= 0) {
            Swal.fire({
                icon: "warning",
                text: "Please fill all required fields ",
            });
            return; 
        }
    
        const payment = {
            from: selectedClient1,
            to: selectedClient2,
            paymentType: paymentType,
            jvType: "CLIENT",
            amount: selectedAmount,
            createdDate: selectedDate,
            remark: selectedRemark
        };

        JvService.getJvEntry(payment).then(resp => {
            if (resp.code === 1) {
                Swal.fire({
                    icon: "success",
                    text: "Success!!.."
                });

                const updatedClients = [...client];

                const updatedClient1 = updatedClients.find(c => c.userid === selectedClient1);
                const updatedClient2 = updatedClients.find(c => c.userid === selectedClient2);

                if (updatedClient1) {
                    updatedClient1.balance -= selectedAmount;  
                    setSelectedBalance1(updatedClient1.balance);
                }

                if (updatedClient2) {
                    updatedClient2.balance = parseFloat(updatedClient2.balance) + parseFloat(selectedAmount);
                    setSelectedBalance2(updatedClient2.balance);
                }


                setSelectedClient1('');
                setSelectedClient2('');
                setSelectedDate(new Date().toISOString().split('T')[0]);  
                setSelectedAmount('');
                setSelectedRemark('');
                setPaymentType('CASH');

            } else {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something Went to Wrong!",
                });
            }
        });
    };

    return (
        <Card className=' mt-2 '>
            <Card.Body>
                <Row>
                    <Col sm={2}>
                        <b className=' fss-08'>DABIT ACCONUT  <b style={{fontSize: '0.9rem', color: 'red'}}>*</b></b>
                    </Col>

                    <Col sm={4}>
                        <Select
                            className='text-black'
                            options={client.map(c => ({
                                label: `${c.firstName} (${c.userName})`,  
                                value: c.userid
                            }))}
                            value={selectedClient1 ? {
                                value: selectedClient1, 
                                label: client.find(c => c.userid === selectedClient1)
                                    ? `${client.find(c => c.userid === selectedClient1).firstName} (${client.find(c => c.userid === selectedClient1).userName})`
                                    : ''
                            } : null}
                            onChange={handleBrokerChange1}
                            placeholder="Select Client"
                            isClearable
                        />
                    </Col>
                    {selectedClient1 && (
                        <Col className='mt-2'>{selectedBalance1}</Col>
                    )}
                </Row>

                <Row className='mt-3'>
                    <Col sm={2}>
                        <b className=' fss-08' style={{ fontSize: 12 }}>CREDIT ACCONUT  <b style={{fontSize: '0.9rem', color: 'red'}}>*</b></b>
                    </Col>

                    <Col sm={4}>
                        <Select
                            className='text-black'
                            options={filteredClientsForCredit.map(c => ({
                                label: `${c.firstName} (${c.userName})`, 
                                value: c.userid
                            }))}
                            value={selectedClient2 ? {
                                value: selectedClient2,
                                label: client.find(c => c.userid === selectedClient2)
                                    ? `${client.find(c => c.userid === selectedClient2).firstName} (${client.find(c => c.userid === selectedClient2).userName})`
                                    : ''
                            } : null}
                            onChange={handleBrokerChange2}  
                            placeholder="Select Client"
                            isClearable
                        />
                    </Col>
                    {selectedClient2 && (
                        <Col className='mt-2'>{selectedBalance2}</Col>
                    )}
                </Row>

                <Row className='mt-3'>
                    <Col sm={2}>
                        <b className=' fss-08'>DATE  <b style={{fontSize: '0.9rem', color: 'red'}}>*</b></b>
                    </Col>

                    <Col sm={4}>
                        <input className="form-control bg-light text-black" type="date" size="lg" value={selectedDate}
                            onChange={handleDateChange} defaultValue={new Date().toISOString().split('T')[0]} />

                    </Col>
                </Row>

                <Row className='mt-3'>
                    <Col sm={2}>
                        <b className='  fss-08'> PAYMENT TYPE</b>
                    </Col>

                    <Col sm={4} >

                        {['radio'].map((type) => (
                            <div key={`inline-${type}`} className="mb-3 border form-control">
                                <Form.Check
                                    inline
                                    label="CASH"
                                    defaultChecked=" "
                                    className='h6 fss-08'
                                    name="group2"
                                    type={type}
                                    id={`inline-${type}-2`}
                                    checked={paymentType === "CASH"}
                                    onChange={handlePaymentTypeChange}
                                    value="CASH"
                                />
                                <Form.Check
                                    inline
                                    label="ONLINE"
                                    className='h6 fss-08'
                                    name="group2"
                                    type={type}
                                    id={`inline-${type}-2`}
                                    checked={paymentType === "ONLINE"}
                                    onChange={handlePaymentTypeChange}
                                    value="ONLINE"
                                />

                            </div>
                        ))}
                    </Col>
                </Row>

                <Row>
                    <Col sm={2}>
                        <b className=' fss-08' >AMOUNT  <b style={{fontSize: '0.9rem', color: 'red'}}>*</b></b>
                    </Col>

                    <Col sm={4}>
                        <input type='number' className='bg-light text-black form-control' value={selectedAmount}
                            onChange={handleAmountChange} />
                    </Col>

                </Row>

                <Row className='mt-3'>
                    <Col sm={2}>
                        <b className=' fss-08'>REMARKS</b>
                    </Col>

                    <Col sm={4}>
                        <input type="text" className="form-control bg-light text-black" id="exampleFormControlInput1"
                            value={selectedRemark}
                            onChange={handleRemarkChange} />
                    </Col>
                </Row>

                <Row className='mt-2'>
                    <Col sm={2}>

                    </Col>

                    <Col sm={4}>

                        <Button className='w-25' variant="success" onClick={jvEntry}>Save</Button>{' '}
                        <Button className='w-25' variant="danger" onClick={jvClear}>Clear</Button>

                    </Col>
                </Row>

            </Card.Body>
        </Card>


    );
}
export default Jv;